import React, {useState, useEffect} from 'react'
import VerCertificados from './VerCertificados'
import SubirEditCertifi from './SubirEditCertifi'
import Eliminar  from '../componentes/Eliminar'
import Header from '../componentes/Header';
import useTraeDatos from '../hooks/useTraeDatos';
import {Titulos, peticionDelete} from '../hooks/Funciones'

const CertificadosAdmin = ({titulo, urlCertificados, urlUsuarios, urlCursos}) => {

	const [tituloPag, setTituloPag] = useState(titulo)
	const [registroSelect, setRegistroSelect] = useState({})
	const [funcion, setFuncion] = useState('ver')
	const [certificados, setCertificados] = useTraeDatos(urlCertificados)
	const TitulosPagina = ['Ver Certificados', 'Crear Certificado', 'Editar Certificado', 'Eliminar Certificado', 'Certificados']
	const [copiaArray, setCopiaArray] = useTraeDatos(urlCertificados)
	const [busqueda, setBusqueda] = useState('')

	const seleccionaRegistro = (dato, funcion) => e =>{
		console.log('prepa',{...dato, imagePrev: dato.imagen, imagen: dato.archivo})
		setRegistroSelect({...dato, imagePrev: dato.archivo, imagen: dato.archivo})
		setFuncion(funcion === 'eliminar' ? 'eliminar' : 'editar')
	}

	const peticionDeletee = () =>{peticionDelete(registroSelect, urlCertificados, certificados, setCertificados, setFuncion)}
	useEffect(() => {Titulos (funcion, setTituloPag, TitulosPagina)},[funcion])

	const RecibeBusqueda = e => {
		setBusqueda(e.target.value)
		filtrar(e.target.value)
	}

	const filtrar = (termino) => {
		let resultado = copiaArray.filter((item) => {
			if(item.nombre.toLowerCase().includes(termino.toLowerCase())){
				return item
			} 
		})
		setCertificados(resultado)
	}

	const ReiniciarPaginacion = () => {
		setCertificados(copiaArray)
		setBusqueda('')
	}

	return(
		<div>
			<Header 
				titulo={tituloPag} 
				funcion={funcion} 
				setFuncion={setFuncion} 
				Pagina={'certificados'} 
				RecibeBusqueda={RecibeBusqueda} 
				busqueda={busqueda}
				resetBusq={ReiniciarPaginacion}
			/>
            {funcion === 'crear' ?
                <SubirEditCertifi
					baseUrl={urlCertificados} 
					urlUsuarios={urlUsuarios}
					setFuncion={setFuncion}
					data={certificados} 
					setData={setCertificados}
					TituloBtn={tituloPag}
					setTituloPag={setTituloPag} 
					funcion={funcion}
					urlCursos={urlCursos}/>
			:null}
			{funcion === 'ver' ?
				<VerCertificados
					data={certificados} 
					seleccionaRegistro={seleccionaRegistro}
					setFuncion={setFuncion}
					setRegistroSelect={setRegistroSelect}
					baseUrl={urlCertificados}
				/>
			:null}
			{funcion === 'eliminar' ?
				<Eliminar 
					nombre={'Certificado'}
					select={registroSelect}
					setFuncion={setFuncion}
					peticionDelete={peticionDeletee}/>
				
			:null}
		</div>
	)
}

export default CertificadosAdmin